import { render } from "./initPage.vue?vue&type=template&id=584e2fd5&scoped=true"
import script from "./initPage.vue?vue&type=script&lang=js"
export * from "./initPage.vue?vue&type=script&lang=js"

import "./initPage.vue?vue&type=style&index=0&id=584e2fd5&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584e2fd5"]])

export default __exports__